import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { MdAdd } from "react-icons/md";
import { FaMoneyBillWave } from "react-icons/fa";
import { FiInfo } from "react-icons/fi";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box,
  IconButton,
} from "@mui/material";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

import {
  deleteCashFlowApi,
  getCashFlowApi,
} from "../../services/CashFlowService";
import { subDays, startOfMonth, endOfMonth, subMonths } from "date-fns";
import AddCashFlowModal from "./AddCashFlowModal";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import {
  CashFlowOption,
  dateRangeOptions,
  formatToIndianNumber,
} from "../../utilities";
import DatePicker from "react-datepicker";
import { RiPaypalFill } from "react-icons/ri";
import { CustomTooltip } from "../../components/CustomTooltip";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { MdTouchApp } from "react-icons/md";
import { MdOutlineClose } from "react-icons/md";
import { gettActionNotification } from "../../services/DashboardService";
const CashFlow = () => {
  const userRole = useSelector((state) =>
    state.auth.user?.is_superuser ? "admin" : "user" || ""
  );
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [selectedData, setSelectedData] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setdeleteLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedCategory, setSelecetdCategory] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dateRangeOptions[4]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [paymentRejectLoading, setPaymentRejectLoading] = useState(false);
  const [paymentApproveLoading, setPaymentApproveLoading] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);

  const handlePaymentToggle = () => {
    if (paymentOpen) {
      setSelectedData(null);
    }
    setPaymentOpen(!paymentOpen);
  };

  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
    category: "",
    start_date: format(subDays(new Date(), 30), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
  });

  useEffect(() => {
    const category = selectedCategory?.value || "";
    if (param?.category !== category) {
      setParam({ ...param, category: category });
    }
  }, [selectedCategory]);
  const handleToggleDelete = () => {
    if (deleteModal) {
      setSelectedData(null);
    }
    setDeleteModal(!deleteModal);
  };

  const handleToggleAddModal = () => {
    if (addModal) {
      setSelectedData(null);
    }
    setAddModal(!addModal);
  };

  const deleteCashFlow = () => {
    setdeleteLoading(true);
    deleteCashFlowApi(selectedData?.id || "")
      .then((res) => {
        toast.success("Delete Successfully");
        handleToggleDelete();
        getData();
      })
      .finally(() => {
        setdeleteLoading(false);
      });
  };
  const getData = () => {
    setLoading(true);
    getCashFlowApi(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results?.data || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [param]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleAfterCashFlowAdd = () => {
    handleToggleAddModal();
    getData();
  };
  const handleDateRangeChange = (option) => {
    setSelectedDate(option);
    if (!option) {
      setParam({
        ...param,
        start_date: "",
        end_date: "",
        page: "1",
      });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "today":
        startDate = new Date();
        endDate = new Date();
        break;
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };

  const getValueByKey = (obj, key) => {
    return key
      .split(".")
      .reduce((acc, part) => (acc ? acc[part] : undefined), obj);
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <FaSort className="sort-icon neutral" />;
    }
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sort-icon active" />
    ) : (
      <FaSortDown className="sort-icon active" />
    );
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...data].sort((a, b) => {
      const valA = getValueByKey(a, key);
      const valB = getValueByKey(b, key);

      const numA = parseFloat(valA);
      const numB = parseFloat(valB);
      const dateA = Date.parse(valA);
      const dateB = Date.parse(valB);

      // Numeric sort if both are valid numbers
      if (!isNaN(numA) && !isNaN(numB)) {
        return direction === "asc" ? numA - numB : numB - numA;
      }

      // Date sort if both are valid dates
      if (!isNaN(dateA) && !isNaN(dateB)) {
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }

      // Fallback to string sort (letters, "inf", etc.)
      return direction === "asc"
        ? String(valA).localeCompare(String(valB), undefined, {
            sensitivity: "base",
          })
        : String(valB).localeCompare(String(valA), undefined, {
            sensitivity: "base",
          });
    });

    setData(sorted);
  };
  const handlePaymentAction = (type) => {
    if (type == "approve") {
      setPaymentApproveLoading(true);
    } else {
      setPaymentRejectLoading(true);
    }
    gettActionNotification(selectedData?.id || "", { action: type })
      .then((res) => {
        handlePaymentToggle();
        getData();
        toast.success("Update successfully");
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        if (type == "approve") {
          setPaymentApproveLoading(false);
        } else {
          setPaymentRejectLoading(false);
        }
      });
  };
  return (
    <div>
      <div className="card">
        <div className="p-4 d-flex justify-content-between flex-wrap gap-2">
          <div className="d-flex gap-1 flex-fill flex-md-grow-0">
            {/* <span className="btn btn-outline-light rounded-2 p-2">
              <FaArrowLeft className="text-dark" />
            </span> */}
            <div className="flex-fill">
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
            </div>
          </div>
          <div className="d-flex gap-2 flex-wrap">
            <div>
              <GlobalSearchableDropdown
                options={CashFlowOption}
                selected={selectedCategory}
                onSelect={(item) => setSelecetdCategory(item)}
                placeholder="Category"
              />
            </div>
            {showDatePicker && (
              <div className="">
                <DatePicker
                  selectsRange
                  startDate={
                    param?.start_date ? new Date(param.start_date) : null
                  }
                  endDate={param?.end_date ? new Date(param.end_date) : null}
                  onChange={(update) => {
                    const [start, end] = update;
                    setParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                      page: 1,
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  style={{
                    fontSize: "0.5rem",
                  }}
                />
              </div>
            )}
            <div className="">
              <GlobalSearchableDropdown
                options={dateRangeOptions}
                selected={selectedDate}
                onSelect={(item) => handleDateRangeChange(item)}
                placeholder="Period"
              />
            </div>
            {userRole == "user" && (
              <div>
                <button
                  className="btn btn-primary px-2"
                  onClick={handleToggleAddModal}
                  style={{ padding: "0.45rem 0" }}
                >
                  <MdAdd className="me-1" size="20" />
                  Add CashFlow
                </button>
              </div>
            )}
          </div>
        </div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-center my-4 text-danger">{error}</div>
        ) : data && data?.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th
                    onClick={() => handleSort("category")}
                    style={{ cursor: "pointer" }}
                  >
                    CashFlow Category{renderSortIcon("category")}
                  </th>
                  <th
                    onClick={() => handleSort("description")}
                    style={{ cursor: "pointer" }}
                  >
                    Description{renderSortIcon("description")}
                  </th>
                  {userRole == "admin" && (
                    <th
                      onClick={() => handleSort("service_center_name")}
                      style={{ cursor: "pointer" }}
                    >
                      Service Center{renderSortIcon("service_center_name")}
                    </th>
                  )}
                  <th
                    onClick={() => handleSort("amount")}
                    style={{ cursor: "pointer" }}
                  >
                    Amount{renderSortIcon("amount")}
                  </th>
                  <th
                    onClick={() => handleSort("payment_mode_display")}
                    style={{ cursor: "pointer" }}
                  >
                    Payment Source{renderSortIcon("payment_mode_display")}
                  </th>
                  {userRole == "admin" && (
                    <th
                      onClick={() => handleSort("created_by_name")}
                      style={{ cursor: "pointer" }}
                    >
                      Created By{renderSortIcon("created_by_name")}
                    </th>
                  )}
                  <th
                    onClick={() => handleSort("date")}
                    style={{ cursor: "pointer" }}
                  >
                    Date{renderSortIcon("date")}
                  </th>
                  {userRole == "user" && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={item.id}>
                    <td>
                      <div>
                        {item?.category || "-"}
                        {item?.status && (
                          <span
                            className={`ms-1 badge ${
                              item?.status.toLowerCase() == "approved"
                                ? "text-bg-success-soft"
                                : item?.status.toLowerCase() == "pending"
                                ? "text-bg-warning-soft border border-warning cursor-pointer text-dark"
                                : "text-bg-danger-soft"
                            }`}
                            style={{ fontSize: "0.55rem" }}
                            onClick={
                              item?.status.toLowerCase() == "pending" &&
                              userRole == "admin"
                                ? () => {
                                    setSelectedData(item);
                                    handlePaymentToggle();
                                  }
                                : undefined
                            }
                          >
                            {item?.status.toLowerCase() == "pending" &&
                              userRole == "admin" && (
                                <MdTouchApp
                                  style={{
                                    marginBottom: "0.2rem",
                                    marginRight: "0.2rem",
                                  }}
                                />
                              )}
                            {item?.status}
                          </span>
                        )}
                        {(item?.advance_user_name ||
                          item?.advance_employee_name) && (
                          <span
                            className="ms-1 border-start ps-1 fw-medium"
                            style={{ fontSize: "0.75rem" }}
                          >
                            (
                            {item?.advance_user_name ||
                              item?.advance_employee_name ||
                              ""}
                            )
                          </span>
                        )}
                      </div>
                    </td>
                    <td>{item?.description || "-"}</td>
                    {userRole == "admin" && (
                      <td>{item?.service_center_name || "-"}</td>
                    )}
                    <td>
                      {item?.amount
                        ? `₹${formatToIndianNumber(item?.amount)}`
                        : "-"}
                    </td>
                    <td>
                      <div>
                        {item?.payment_mode_display || "-"}
                        {item?.reference_id && (
                          <CustomTooltip title={item?.reference_id || ""}>
                            <span
                              className="btn btn-outline-light ms-1 rounded-1"
                              style={{ padding: "0.2rem" }}
                            >
                              <RiPaypalFill size={10} className="text-dark" />
                            </span>
                          </CustomTooltip>
                        )}
                      </div>
                    </td>
                    {userRole == "admin" && (
                      <td>{item?.created_by_name || "-"}</td>
                    )}
                    <td>
                      {item?.date
                        ? format(new Date(item?.date), "dd MMM yyy")
                        : "-"}
                    </td>
                    {userRole == "user" && (
                      <td>
                        <div className="d-flex gap-1 align-self-start">
                          <span
                            className="p-1 btn btn-outline-light ms-1"
                            onClick={() => {
                              setSelectedData(item);
                              handleToggleAddModal();
                            }}
                          >
                            <FiEdit2 className="text-dark" size="12" />
                          </span>
                          <span
                            className="p-1 btn btn-outline-light ms-1"
                            onClick={() => {
                              setSelectedData(item);
                              handleToggleDelete();
                            }}
                          >
                            <FiTrash2 className="text-dark" size="12" />
                          </span>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">No data found</div>
        )}
        {!loading && data?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>
      <AddCashFlowModal
        data={selectedData || null}
        visible={addModal}
        onClose={handleToggleAddModal}
        onAfterSubmit={handleAfterCashFlowAdd}
      />
      <Dialog
        maxWidth="xs"
        fullWidth
        open={deleteModal}
        onClose={handleToggleDelete}
      >
        <DialogContent className="p-2">
          <Box display="flex" alignItems="flex-start" gap={1}>
            <FiInfo size={20} color="#1976d2" style={{ marginTop: "4px" }} />
            <Typography variant="body1">
              Are you sure you want to delete{" "}
              <strong style={{ color: "red" }}>{selectedData?.category}</strong>
              ? This action cannot be undone.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleToggleDelete}
            color="inherit"
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <Button color="error" variant="contained" onClick={deleteCashFlow}>
            {deleteLoading && <Spinner animation="border" size="sm" />}
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={paymentOpen}
        onClose={handlePaymentToggle}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3 },
        }}
      >
        <DialogTitle className="d-flex justify-content-end p-0 pt-2 px-2">
          <IconButton onClick={handlePaymentToggle} size="small">
            <MdOutlineClose className="text-dark" />
          </IconButton>
        </DialogTitle>

        <div className="px-4 pb-3 text-center">
          <div className="d-flex justify-content-center align-items-center mb-2">
            <div
              className="text-bg-success-soft border border-success rounded-circle d-flex justify-content-center align-items-center shadow-sm"
              style={{ width: 60, height: 60 }}
            >
              <FaMoneyBillWave size={28} />
            </div>
          </div>

          <h5 className="fw-bold mb-2">
            ₹{formatToIndianNumber(selectedData?.amount)}
          </h5>

          <p className="text-darker mb-0" style={{ fontSize: "0.9rem" }}>
            Please confirm if you have <strong>received the cash</strong>.
            <br />
            You can <span className="text-success fw-semibold">
              Accept
            </span> or <span className="text-danger fw-semibold">Reject</span>{" "}
            this confirmation.
          </p>
        </div>
        <DialogActions className="justify-content-center border-top py-2">
          <Button
            variant="outlined"
            color="error"
            startIcon={<FaTimesCircle />}
            className="px-4"
            onClick={() => handlePaymentAction("reject")}
            disabled={paymentApproveLoading || paymentRejectLoading}
          >
            {paymentRejectLoading && <Spinner animation="border" size="sm" />}
            Reject
          </Button>
          <Button
            variant="contained"
            color="success"
            startIcon={<FaCheckCircle />}
            className="px-4"
            onClick={() => handlePaymentAction("approve")}
            disabled={paymentApproveLoading || paymentRejectLoading}
          >
            {paymentApproveLoading && <Spinner animation="border" size="sm" />}
            Accept
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CashFlow;
